
const toggleDropdown = (el) => {

    el.classList.toggle('active');

    let target = document.querySelector(el.getAttribute('data-dropdown-toggle'));
    let icon = el.querySelector('.icon-dropdown');
    icon.classList.toggle('rotate-180');
    ['opacity-0','pointer-events-none', '-translate-y-2'].forEach((c) => target.classList.toggle(c));
    el.parentNode.classList.toggle('z-20');
};

const init = () => {

    // Drop
    const dropdowns = document.querySelectorAll('[data-dropdown-toggle]');

    if(dropdowns.length > 0) {
        dropdowns.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();

                toggleDropdown(el);

                dropdowns.forEach(function (drp) {
                    if(drp.classList.contains('active') && drp != el) {
                        toggleDropdown(drp);
                    }
                });
            });

            el.nextElementSibling.querySelectorAll('a').forEach((link) => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();

                    toggleDropdown(el);
                });
            });
        });
    }
};

export default { init };
